import React from 'react';

import { handleSuggestedQuestionClick } from '../../store/dashboard/askAica/globalAskAicaService';

import MagicUploadSvg from '../../assets/Svg/MagicUploadSvg.svg';

import styles from './AskAicaQuestionBadge.module.scss';

type Props = {
    question: string;
    prompt?: string;
};

const AskAicaQuestionBadge: React.FC<Props> = ({ question, prompt }) => {
    const handleClick = () => {
        handleSuggestedQuestionClick(prompt ?? question);
    };
    return (
        <div className={styles.AskAicaQuestionBadge} onClick={handleClick}>
            <img src={MagicUploadSvg} alt="AI generated" />
            <div className={styles.AskAicaQuestionBadgeText}>{question}</div>
        </div>
    );
};

export default AskAicaQuestionBadge;
